<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" style="min-height: 500px;">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="$emit('close')"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
            <span class="sr-only">Close</span>
            <!-- Heroicon name: x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{ location.address }}, <span class="text-muted">{{ location.city.name }}</span>
              </h3>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            </div>
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                <template v-if="location.primary_company">
                  <h5 class="mb-4">{{ transEdit('company-name') }}: {{ location.primary_company.name }}</h5>
                </template>
                <template v-else>
                  <h5 class="mb-4">{{ transEdit('company-name') }}: {{ location.companies[0].name }}</h5>
                </template>
              </h3>

              <div class="mt-4" v-if="location.info">
                <div class="font-weight-bold">{{ transEdit('location.information-about-location') }}:</div>
                <div><p class="mt-1 text-sm text-gray-500">{{ location.info }}</p></div>
              </div>

              <div class="mt-4" v-if="location.massagetable_information">
                <div class="font-weight-bold">{{ transEdit('location.information-about-bench') }}:</div>
                <div><p class="mt-1 text-sm text-gray-500">{{ location.massagetable_information }}</p></div>
              </div>
              <template v-if="location.info || location.massagetable_information">
                <br v-if="location.info && location.massagetable_information">
              </template>
              <template v-else>
                <div class="col-span-6">
                  {{ transEdit('location.no-info-location-or-bench') }}
                </div>
              </template>
            </div>
          </div>
          <div class="pt-5">
            <div class="flex justify-end">
              <button type="button" @click="$emit('close')"
                      class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TherapistDashModalShowLocationInfo",
  props: ['location'],
}
</script>

<style scoped>

</style>